module.exports = __webpack_public_path__ + "static/media/obituary_icon.0a318fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/obituary_icon.png
// module id = 1594
// module chunks = 0